import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Sidebar({ className }) {
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);

  console.log(events)

  useEffect(() => {
    async function fetchEvents() {
      try {
        const res = await fetch("/api/events", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!res.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await res.json();

        // Your backend just returns array, no {success} field, so just set data directly
        setEvents(data);
      } catch (error) {
        console.error("Failed to fetch events:", error);
      }
    }

    fetchEvents();
  }, []);

  const handleDetails = (id) => {
    navigate(`/Event/${id}`);
  };

  const handleCreate = () => {
    navigate(`/Homepage`);
  };

  return(
    <>
      {/* Left Sidebar */}
      {/* <div className="w-64 bg-gray-500 shadow h-[calc(100vh-64px)] p-6"> */}
      <div className={`${className} bg-gray-500 shadow p-6 h-full`}>
        <h2 className="text-xl font-bold text-white mb-4">Events</h2>
        <hr />
        {/* Sidebar items */}
        <div className="space-y-4 pt-4">
          <h3 className="flex items-center justify-center text-lg font-semibold text-white cursor-pointer hover:text-yellow-300 h-10" onClick={handleCreate}>
            <span className="leading-none">Create</span>
            <FontAwesomeIcon icon={faPlusCircle} className="text-base" />
          </h3>
          {events.length > 0 ? (
            events.map((event, index) => (
              <h3
                key={index}
                className="text-lg font-semibold text-white cursor-pointer hover:text-yellow-300"
                onClick={() => handleDetails(event._id)}
              >
                {event.event_name}
              </h3>
            ))
          ) : (
            <h3 className="text-lg italic text-white">No event available</h3>
          )}
        </div>
      </div>
    </>
  );
}

export default Sidebar;